module.exports = __webpack_public_path__ + "img/xinghao.075e225d.png";